import { Input, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { Flex } from 'reflexbox';
import {
  BackButton,
  MainTitle,
  TabsContainer
} from '../../healtheraComponents';
import DashboardTabs from '../DashboardPage/components/DashboardTabs';
import { ROUTES } from '../Routes/constants';
import OrgTypesTabs from './OrgTypesTabs'
import ECommerceTabs from '../ECommerce/ECommerceTabs';
import CampaignTabs from '../Campaigns/CampaignTabs';
import ServicesTabs from '../Services/ServicesTabs';
import ClinicsSearchTabs from '../Clinics/ClinicsList/components/ClinicsSearchTabs';

const SearchTabs = ({
  displayMenu,
  previousPage,
  onGoBack,
  onViewChange,
  superRoute,
}) => {

  return (
    <TabsContainer w={8 / 10} align="center">
      {!displayMenu && previousPage && (
        <Flex align="center" onClick={onGoBack}>
          <BackButton padding={`3px 0 0 0`} />
          <MainTitle cursor={`pointer`}>
            {previousPage}
          </MainTitle>
        </Flex>
      )}
      {displayMenu && (
        <MainTitle>
          <Select input={<Input disableUnderline />} value={superRoute} onChange={onViewChange}>
            <MenuItem value={ROUTES.ANNOUNCEMENTS}>Announcements</MenuItem>
            <MenuItem value={ROUTES.CAMPAIGNS}>Campaigns</MenuItem>
            <MenuItem value={ROUTES.CLINICS}>Clinics</MenuItem>
            <MenuItem value={`${ROUTES.ECOMMERCE}/banners`}>E-Commerce</MenuItem>
            <MenuItem value={ROUTES.PROBLEMATIC_PHARMACIES}>Live Order Support</MenuItem>
            <MenuItem value={ROUTES.DASHBOARD}>Live Order Support v2</MenuItem>
            <MenuItem value={ROUTES.ORGANISATIONS}>Organisations</MenuItem>
            <MenuItem value={ROUTES.QUESTIONNAIRES}>Questionnaires</MenuItem>
            <MenuItem value={ROUTES.REGIONS}>Regions</MenuItem>
            <MenuItem value={`${ROUTES.SERVICES}/consultations`}>Services</MenuItem>
            <MenuItem value={ROUTES.SURGERIES}>Surgeries</MenuItem>
            <MenuItem value={ROUTES.WHITELABELS}>White Labels</MenuItem>
          </Select>
        </MainTitle>
      )}

      {superRoute === ROUTES.ORGANISATIONS && <OrgTypesTabs/>}
      {superRoute === ROUTES.CAMPAIGNS && <CampaignTabs />}
      {superRoute === ROUTES.ECOMMERCE && <ECommerceTabs />}
      {superRoute === ROUTES.DASHBOARD && <DashboardTabs/>}
      {superRoute === ROUTES.SERVICES && <ServicesTabs />}
      {superRoute === ROUTES.CLINICS && <ClinicsSearchTabs />}
    </TabsContainer>
  );
};

export default SearchTabs;
